import { render, staticRenderFns } from "./Superpasses.vue?vue&type=template&id=53fc2223"
import script from "./Superpasses.vue?vue&type=script&lang=js"
export * from "./Superpasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports